import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import styled from '@xstyled/styled-components';
import { BaseText } from './root-text.component';
import { handleColorType, handleFontSize, handleFontWeight } from '../text-styles';
import { jsx as _jsx } from "react/jsx-runtime";
var StyledBaseText = styled(BaseText)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  font-size: ", ";\n  color: ", ";\n  font-weight: ", ";\n"])), function (_ref) {
  var size = _ref.size;
  return handleFontSize(size);
}, function (_ref2) {
  var $colorType = _ref2.$colorType;
  return handleColorType($colorType);
}, function (_ref3) {
  var fontWeight = _ref3.fontWeight;
  return handleFontWeight(fontWeight);
});
export var DefaultText = function DefaultText(props) {
  var fontWeight = props.fontWeight,
      size = props.size,
      colorType = props.colorType,
      children = props.children;
  return /*#__PURE__*/_jsx(StyledBaseText, _objectSpread(_objectSpread({
    $colorType: colorType,
    fontWeight: fontWeight,
    size: size
  }, props), {}, {
    children: children
  }));
};